import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import {
  IBillPayRequest,
  IBillPayResponse,
  IClientPortalDetailsResponse,
  IPortalLink,
} from '../models/billing.model';

@Injectable({ providedIn: 'root' })
export class BillPayService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.apiUrl}/client-portal`;

  getDetails(): Observable<IClientPortalDetailsResponse> {
    return this.http.get<IClientPortalDetailsResponse>(`${this.baseUrl}/details`);
  }

  getPortalLink(page: string): Observable<IPortalLink> {
    return this.http.get<IPortalLink>(`${this.baseUrl}/portal-link`, { params: { page } });
  }

  submitPayment(request: IBillPayRequest): Observable<IBillPayResponse> {
    return this.http.post<IBillPayResponse>(`${this.baseUrl}/bill-pay`, request);
  }
}
